<template>
	<div class="adminpricelist">
		<header>
			<h2>Aktualizacja cennika</h2>
		</header>

		<div class="adminpricelist__content">
			<a href="/api/v1/pricelist" class="button adminpricelist__download-latest button--outlined">
				Pobierz aktualny cennik
			</a>
			<div>
				<div class="adminpricelist__upload-wrapper">
					<input @change.prevent="fileChange" type="file" name="pricelist" accept=".csv" />
				</div>
				<button
					@click.prevent="updatePricelist"
					role="button"
					class="button adminpricelist__update button--outlined"
					:disabled="!pricelist"
				>
					Zaktualizuj cennik
				</button>
				<p>{{ error || success }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import {api} from '@/core/services/api';
import PartnerList from './PartnerList';

export default {
	name: 'AdminDashboard',
	mixins: [AppDataMixin],
	data() {
		return {
			error: '',
			success: '',
			pricelist: '',
		};
	},
	methods: {
		fileChange(ev) {
			this.error = '';
			this.pricelist = '';

			const reader = new FileReader();
			const file = ev.target.files[0];

			reader.onload = e => {
				this.pricelist = e.target.result;
			};

			reader.onerror = e => {
				this.error = 'Wystąpił błąd przy próbie przetworzenia pliku.';
			};

			reader.readAsText(file);
		},
		updatePricelist() {
			return api
				.patch('/pricelist', {payload: this.pricelist})
				.then(() => {
					this.success = 'Ceny zostały pomyślnie zaktualizowane.';
				})
				.catch(() => {
					this.error =
						'Wystąpił błąd przy próbie uploadu pliku. Proszę zwrócić uwagę na prawidłowy format ceny i wybór przecinka jako separatora.';
				});
		},
	},
};
</script>
